// src/pages/homepage/homepage.component.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './homepage.styles.scss';

const Homepage = () => {
  const whatsappLink = "https://wa.me/923224314712";
  const youtubeChannel = "https://www.youtube.com/@crispyhairsolutionpvtltd2064";
  const youtubeChannelId = "UCzoALIJ93bWMXc5QMqxaZjg";
  const facebookLink = "https://www.facebook.com/CrispyHairSolution/";
  const instagramLink = "https://www.instagram.com/crispyhair.solution/";
  const mapLink = "https://maps.app.goo.gl/srh739P8w5n1uCMw5";

  // ===== YOUTUBE VIDEOS DATA =====
  const [activeTab, setActiveTab] = useState('all');

  // All videos from your YouTube channel
  const youtubeVideos = [
    // Full Videos
    { 
      id: '7ymPITefPUw', 
      title: 'Crispy Hair - Premium Hair Solutions',
      type: 'video',
      description: 'Discover our premium hair wigs and patches collection'
    },
    { 
      id: 'ChJx7u4v5uM', 
      title: 'Hair Wigs Collection - 100% Human Hair',
      type: 'video',
      description: 'Best quality human hair wigs in Pakistan'
    },
    { 
      id: 'F6US1Ip2w0M', 
      title: 'Hair Patches - Best Quality',
      type: 'video',
      description: 'Premium hair patches for natural look'
    },
    { 
      id: 'WhnhaGC7E2o', 
      title: 'Hair Replacement Solutions',
      type: 'video',
      description: 'Advanced hair replacement techniques'
    },
    { 
      id: 'hxmceQSTp9g', 
      title: 'Hair Extensions - Premium Quality',
      type: 'video',
      description: '100% human hair extensions'
    },
    
    // YouTube Shorts
    { 
      id: 'nkru6T7-h-Q', 
      title: 'Quick Hair Tip #1',
      type: 'short',
      description: 'Hair care tips for wigs'
    },
    { 
      id: 'UhbLAi2p748', 
      title: 'Quick Hair Tip #2',
      type: 'short',
      description: 'Hair patch installation guide'
    },
    { 
      id: 'ReauC8vk6is', 
      title: 'Quick Hair Tip #3',
      type: 'short',
      description: 'Wig maintenance tips'
    },
    { 
      id: 'P7zTVSbhQdo', 
      title: 'Quick Hair Tip #4',
      type: 'short',
      description: 'Hair extension care'
    },
    { 
      id: 'MVj3bzUtwrM', 
      title: 'Quick Hair Tip #5',
      type: 'short',
      description: 'Natural hairline tips'
    },
    { 
      id: 'iU8fQ9IPFnA', 
      title: 'Quick Hair Tip #6',
      type: 'short',
      description: 'Hair unit styling'
    },
    { 
      id: '4nFmJnCUNVw', 
      title: 'Quick Hair Tip #7',
      type: 'short',
      description: 'Hair patch application'
    },
    { 
      id: 'vmvJZWBaIiY', 
      title: 'Quick Hair Tip #8',
      type: 'short',
      description: 'Wig styling tips'
    },
    { 
      id: 'xoIxNdXEQxI', 
      title: 'Quick Hair Tip #9',
      type: 'short',
      description: 'Hair care routine'
    }
  ];

  // Filter videos based on active tab
  const filteredVideos = activeTab === 'all' 
    ? youtubeVideos 
    : youtubeVideos.filter(v => v.type === activeTab);

  return (
    <div className="homepage">
      {/* ===== HERO SECTION ===== */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <span className="badge">✨ Premium Hair Solutions</span>
            <h1>
              Your Trusted <br />
              <span className="highlight">Hair Solution</span> Partner
            </h1>
            <p>
              100% original human hair wigs, hair patches, hair units, and 
              hair replacement solutions in Pakistan, Saudi Arabia & Other Gulfs. Best quality, best prices.
            </p>
            <div className="hero-buttons">
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-primary"
              >
                📱 Order Now
              </a>
              <Link to="/hair-centers" className="btn-secondary">
                Browse Products
              </Link>
            </div>
          </div>
          <div className="hero-image">
            <div>
              <img 
                src="/hero-image.jpg" 
                alt="Crispy Hair Solution" 
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Happy Clients</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <span className="stat-label">Original Hair</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">4.9⭐</span>
                  <span className="stat-label">Rating</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============================================================
          🆕 NEW SECTION 1 - SEO: HAIR PATCH NEAR ME
          (Add this AFTER Hero, BEFORE Categories)
          ============================================================ */}
      <section className="seo-section">
        <div className="container">
          <div className="seo-header">
            <h2 className="seo-title">
              Hair Patch <span>Near Me</span> – Best Wigs in Rawalpindi
            </h2>
            <p className="seo-subtitle">
              Looking for a <strong>hair patch near me</strong>? Crispy Hair Solution offers premium 
              human hair wigs, hair patches, and hair extensions in Rawalpindi, Islamabad, Lahore &amp; Karachi.
            </p>
          </div>

          <div className="seo-grid">
            <div className="seo-card">
              <div className="seo-icon">💇</div>
              <h3>Hair Patch Near Me</h3>
              <p>
                Find the best <strong>hair patch near me</strong> in Rawalpindi. 
                We offer premium hair patches for men and women at affordable prices.
              </p>
              <ul className="seo-list">
                <li>✓ Natural looking hair patches</li>
                <li>✓ 100% human hair</li>
                <li>✓ Custom fit for men & women</li>
                <li>✓ Starting from Rs. 5,000</li>
              </ul>
              <a href="https://wa.me/923224314712" target="_blank" rel="noopener noreferrer" className="seo-btn">
                Order Now →
              </a>
            </div>

            <div className="seo-card">
              <div className="seo-icon">👩</div>
              <h3>Hair Wigs &amp; Extensions</h3>
              <p>
                Premium <strong>hair wigs</strong> and <strong>hair extensions</strong> 
                in Rawalpindi. 100% original human hair wigs for men and women.
              </p>
              <ul className="seo-list">
                <li>✓ Human hair wigs</li>
                <li>✓ Lace front wigs</li>
                <li>✓ Full lace wigs</li>
                <li>✓ Clip-in & tape-in extensions</li>
              </ul>
              <a href="https://wa.me/923224314712" target="_blank" rel="noopener noreferrer" className="seo-btn">
                Browse Wigs →
              </a>
            </div>

            <div className="seo-card">
              <div className="seo-icon">🏪</div>
              <h3>Wig Shop Rawalpindi</h3>
              <p>
                Visit our <strong>wig shop in Rawalpindi</strong> at Asim Plaza. 
                We serve customers from all over Rawalpindi and Islamabad.
              </p>
              <ul className="seo-list">
                <li>✓ Shop in Rawalpindi</li>
                <li>✓ Serving Islamabad too</li>
                <li>✓ Free consultation</li>
                <li>✓ Delivery across Pakistan</li>
              </ul>
              <a href={mapLink} target="_blank" rel="noopener noreferrer" className="seo-btn">
                Visit Our Shop →
              </a>
            </div>
          </div>

          <div className="seo-cta">
            <p>
              <strong>Need a hair patch near me?</strong> Call us now for the best hair solutions!
            </p>
            <a href="tel:+923224314712" className="seo-cta-btn">
              📞 Call +92 322 4314712
            </a>
          </div>
        </div>
      </section>

      {/* ===== CATEGORIES SECTION ===== */}
      <section className="categories-section">
        <div className="section-header">
          <h2 className="section-title">Our Premium Products</h2>
          <p className="section-subtitle">100% human hair products for all your needs</p>
        </div>
        <div className="categories-grid">
          <Link to="/men-wigs" className="category-card">
            <span className="category-icon">💇</span>
            <h3>Men's Wigs</h3>
            <p>100% human hair wigs for men</p>
          </Link>
          <Link to="/lady-hair" className="category-card">
            <span className="category-icon">💁</span>
            <h3>Lady Hair Extensions</h3>
            <p>Premium hair extensions for women</p>
          </Link>
          <Link to="/new-arrivals" className="category-card">
            <span className="category-icon">✨</span>
            <h3>New Arrivals</h3>
            <p>Latest products just arrived</p>
          </Link>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="category-card">
            <span className="category-icon">🪄</span>
            <h3>Hair Patches</h3>
            <p>Best quality hair patches in Pakistan</p>
          </a>
        </div>
      </section>

      {/* ===== YOUTUBE CHANNEL SECTION ===== */}
      <section className="youtube-section">
        <div className="section-header">
          <h2 className="section-title">▶️ Our YouTube Channel</h2>
          <p className="section-subtitle">Watch our latest videos and tutorials</p>
          <a 
            href={youtubeChannel} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="youtube-channel-link"
          >
            📺 Visit Our Channel
          </a>
        </div>

        {/* Video Tabs */}
        <div className="video-tabs">
          <button 
            className={`tab ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => setActiveTab('all')}
          >
            All Videos
          </button>
          <button 
            className={`tab ${activeTab === 'video' ? 'active' : ''}`}
            onClick={() => setActiveTab('video')}
          >
            Full Videos
          </button>
          <button 
            className={`tab ${activeTab === 'short' ? 'active' : ''}`}
            onClick={() => setActiveTab('short')}
          >
            #Shorts
          </button>
        </div>

        {/* Videos Grid */}
        <div className="videos-grid">
          {filteredVideos.map((video) => (
            <div key={video.id} className={`video-card ${video.type}`}>
              <div className="video-thumbnail">
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
                {video.type === 'short' && (
                  <span className="short-badge">#Shorts</span>
                )}
              </div>
              <div className="video-info">
                <h4>{video.title}</h4>
                <p className="video-description">{video.description}</p>
                <p className="video-meta">
                  {video.type === 'short' ? '📱 Short Video' : '▶️ Full Video'}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Channel Subscribe Button */}
        <div className="channel-subscribe">
          <a 
            href={youtubeChannel} 
            target="_blank" 
            rel="noopener noreferrer"
            className="subscribe-btn"
          >
            🔔 Subscribe to Our Channel
          </a>
          <p className="channel-id">Channel ID: {youtubeChannelId}</p>
        </div>
      </section>

      {/* ============================================================
          🆕 NEW SECTION 2 - SEO: AREAS WE SERVE
          (Add this AFTER YouTube, BEFORE Services)
          ============================================================ */}
      <section className="areas-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Areas We <span>Serve</span>
            </h2>
            <p className="section-subtitle">
              Visit our <strong>hair patch shop in Rawalpindi</strong> – serving all areas
            </p>
          </div>

          <div className="areas-grid-new">
            <div className="area-item">📍 Rawalpindi</div>
            <div className="area-item">📍 Islamabad</div>
            <div className="area-item">📍 Lahore</div>
            <div className="area-item">📍 Karachi</div>
            <div className="area-item">📍 Bahria Town</div>
            <div className="area-item">📍 DHA</div>
            <div className="area-item">📍 Gulraiz</div>
            <div className="area-item">📍 Saddar</div>
            <div className="area-item">📍 Satellite Town</div>
            <div className="area-item">📍 Westridge</div>
            <div className="area-item">📍 Chaklala</div>
            <div className="area-item">📍 All Pakistan</div>
          </div>

          <p className="areas-note">
            <strong>Looking for a hair patch shop near me?</strong> We're conveniently located at 
            Asim Plaza, Rawalpindi – visit us today!
          </p>
        </div>
      </section>

      {/* ===== SERVICES SECTION ===== */}
      <section className="services-section">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Comprehensive hair solutions tailored for you</p>
        </div>
        <div className="services-grid">
          <Link to="/hair-transplant" className="service-card">
            <span className="service-icon">🏥</span>
            <h3>Surgical Hair Transplant</h3>
            <p>FUE & FUT techniques with experienced surgeons</p>
          </Link>
          <Link to="/hair-centers" className="service-card">
            <span className="service-icon">🎯</span>
            <h3>Hair Replacement Centers</h3>
            <p>Pakistan,Saudi Arabia & Gulfs</p>
          </Link>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="service-card">
            <span className="service-icon">📋</span>
            <h3>Free Consultation</h3>
            <p>Expert advice on WhatsApp</p>
          </a>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="service-card">
            <span className="service-icon">🛡️</span>
            <h3>Warranty</h3>
            <p>100% satisfaction guarantee</p>
          </a>
        </div>
      </section>

      {/* ===== INFO SECTION ===== */}
      <section className="info-section">
        <div className="info-grid">
          <div className="info-card">
            <span className="info-icon">📍</span>
            <h3>Visit Our Showroom</h3>
            <p>Asim Plaza,F1,Of-24 Chandni chowk Rawalpindi PK +923224314712</p>
            <p>Saudi Arabia only delivery +966531802864</p>
            <a href={mapLink} target="_blank" rel="noopener noreferrer" className="map-link">
              View on Google Maps →
            </a>
          </div>
          <div className="info-card">
            <span className="info-icon">📞</span>
            <h3>Contact Us</h3>
            <p><strong>WhatsApp:</strong> +923224314712</p>
            <p><strong>Email:</strong> crispyhairsolution@gmail.com</p>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="contact-btn">
              💬 Chat on WhatsApp
            </a>
          </div>
          <div className="info-card">
            <span className="info-icon">🌐</span>
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href={instagramLink} target="_blank" rel="noopener noreferrer">📸 Instagram</a>
              <a href={facebookLink} target="_blank" rel="noopener noreferrer">📘 Facebook</a>
              <a href={youtubeChannel} target="_blank" rel="noopener noreferrer">▶️ YouTube</a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WARRANTY SECTION ===== */}
      <section className="warranty-section">
        <h2>🔒 Our Warranty</h2>
        <p>All our hair products come with a comprehensive warranty</p>
        <div className="warranty-features">
          <span>✓ 100% Original Human Hair</span>
          <span>✓ Quality Guarantee</span>
          <span>✓ Replacement Policy</span>
          <span>✓ Free Consultation</span>
        </div>
      </section>

      {/* ============================================================
          🆕 NEW SECTION 3 - SEO: FAQ
          (Add this AFTER Warranty, BEFORE WhatsApp Float)
          ============================================================ */}
      <section className="faq-seo-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Frequently Asked <span>Questions</span>
            </h2>
            <p className="section-subtitle">
              Common questions about our hair patch, wigs, and extensions
            </p>
          </div>

          <div className="faq-seo-grid">
            <div className="faq-seo-item">
              <h3>Where can I find a hair patch near me?</h3>
              <p>
                <strong>Crispy Hair Solution</strong> in Rawalpindi offers premium hair patches 
                for men and women. Visit our shop at Asim Plaza or call us at +923224314712.
              </p>
            </div>

            <div className="faq-seo-item">
              <h3>How much does a hair wig cost in Pakistan?</h3>
              <p>
                Our human hair wigs range from <strong>Rs. 14,000 to Rs. 120,000</strong> 
                depending on quality, length, and style.
              </p>
            </div>

            <div className="faq-seo-item">
              <h3>Do you offer hair extensions in Rawalpindi?</h3>
              <p>
                Yes! We offer clip-in, tape-in, and permanent hair extensions at our 
                Rawalpindi shop. Contact us for more details.
              </p>
            </div>

            <div className="faq-seo-item">
              <h3>What is the price of a hair patch for men?</h3>
              <p>
                Men's hair patches start from <strong>Rs. 14,000</strong> and go up to 
                <strong>Rs. 25,000</strong> based on quality and size.
              </p>
            </div>

            <div className="faq-seo-item">
              <h3>Do you serve Islamabad and Lahore?</h3>
              <p>
                Yes, we serve customers from <strong>Rawalpindi, Islamabad, Lahore, Karachi</strong>, 
                and all across Pakistan. Visit our shop or contact us for delivery options.
              </p>
            </div>

            <div className="faq-seo-item">
              <h3>Do you offer non-surgical hair replacement?</h3>
              <p>
                Yes! We specialize in <strong>non-surgical hair replacement</strong> solutions 
                for men and women. Our custom hair systems look completely natural.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FLOATING WHATSAPP BUTTON ===== */}
      <a 
        href={whatsappLink} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="whatsapp-float"
      >
        💬
        <span className="tooltip">Chat with us!</span>
      </a>
    </div>
  );
};

export default Homepage;